import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[NoDblClick]'
})
export class NoDblClickDirective {
  constructor(public renderer: Renderer2, private hostElement: ElementRef) {
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    let _renderer = this.renderer;
    _renderer.setAttribute(this.hostElement.nativeElement, "disabled", "true");
    let _hostElement = this.hostElement.nativeElement;
    setTimeout(function () {
      _renderer.removeAttribute(_hostElement, "disabled");
    }, 500);
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/ng-confirmations/directives/NoDblClick.directive.ts